import React from 'react';
import {useIntl} from 'umi';
import {ProForm} from '@ant-design/pro-components';

import AppointmentSettingsForm from '@/components/UserDrawer/Edit/AppointmentSettingsForm';
import DrawerSection from '../../Drawer/DrawerSection';
import UserPeriodsForm from './UserPeriodsForm';
import UserOpenHours from '@/components/UserDrawer/Edit/UserOpenHours';

interface UserWorkingHoursProps {
  user: any;
  hideOffDays?: boolean;
  /** Per-service custom calendars don't support a capacity override. */
  hideCapacity?: boolean;
  hidePriority?: boolean;
  /** Hours/off-days editors have no disabled state, so permission-restricted users get them hidden. */
  hideAvailability?: boolean;
  disableSettings?: boolean;
  disablePriority?: boolean;
  onFieldBlur?: (name: string | string[], value: any) => void;
}

const UserWorkingHours: React.FC<UserWorkingHoursProps> = ({user, hideOffDays = false, hideCapacity = false, hidePriority = false, hideAvailability = false, onFieldBlur,  disableSettings = false, disablePriority}) => {
  const intl = useIntl();

  return (
    <ProForm.Item name={'availability'}>
      <AppointmentSettingsForm disabled={disableSettings} disablePriority={disablePriority} hideCapacity={hideCapacity} hidePriority={hidePriority} onFieldBlur={onFieldBlur}/>
      {!hideAvailability && <>
        <DrawerSection collapse title={intl.formatMessage({
          id: 'components.users.workingHour',
          defaultMessage: 'Working Hours',
        })}>
          <ProForm.Item name={['availability', 'working_hours']}>
            <UserOpenHours
              dataFormatter={(_, transformedData) => transformedData}
              supportMultipleEntries={true}
            />
          </ProForm.Item>
        </DrawerSection>

        {!hideOffDays && <DrawerSection
          collapse
          title={intl.formatMessage({
            id: 'pages.users.offHours',
            defaultMessage: 'Set Off Hours',
          })}
        >
          <ProForm.Item name={['availability', 'off_days']}>
            <UserPeriodsForm mode={'off'} />
          </ProForm.Item>
        </DrawerSection>}
        <DrawerSection
          collapse
          title={intl.formatMessage({
            id: 'pages.users.additionalAvailability',
            defaultMessage: 'Additional Availability',
          })}
        >
          <ProForm.Item name={['availability', 'extra_days']}>
            <UserPeriodsForm mode={'open'} />
          </ProForm.Item>
        </DrawerSection>
      </>}
    </ProForm.Item>
  );
};

export default React.memo(UserWorkingHours, () => true);
